import { useState } from "react";
import { validarEmail } from "../utils/validarEmail";

/**
 * Aviso abaixo de um campo de e-mail, com a correcao pronta pra clicar.
 *
 * So aparece depois que a pessoa SAI do campo (onBlur do input chama `marcarTocado`) — avisar a cada
 * tecla acusaria erro no meio da digitacao, quando o e-mail ainda esta pela metade.
 *
 * Uso:
 *   const email = useCampoEmail(form.email, (v) => setForm({ ...form, email: v }));
 *   <input type="email" value={form.email} onChange={...} onBlur={email.aoSair} />
 *   <AvisoEmail {...email.aviso} />
 */
export function AvisoEmail({ erro, sugestao, aplicarSugestao }) {
  if (!erro) return null;
  return (
    <p role="alert" className="-mt-1.5 text-[12px] leading-relaxed text-amber-700">
      ⚠️ {erro}{" "}
      {sugestao && (
        <button type="button" onClick={aplicarSugestao}
          className="font-semibold underline underline-offset-2 hover:opacity-80">
          usar {sugestao}
        </button>
      )}
    </p>
  );
}

/** Estado do aviso para um campo de e-mail controlado. */
export function useCampoEmail(valor, aoCorrigir) {
  const [tocado, setTocado] = useState(false);
  const r = validarEmail(valor);
  const mostrar = tocado && !r.ok;
  return {
    valido: r.ok,
    aoSair: () => setTocado(true),
    // Voltar a digitar limpa o aviso: ele reaparece quando a pessoa sair do campo de novo.
    aoDigitar: () => setTocado(false),
    aviso: {
      erro: mostrar ? r.erro : "",
      sugestao: mostrar ? r.sugestao : null,
      aplicarSugestao: () => { if (r.sugestao) { aoCorrigir(r.sugestao); setTocado(false); } },
    },
  };
}
